import PropTypes from 'prop-types';

export default PropTypes.shape({
    userId: PropTypes.number,
    collaboratorId: PropTypes.string,
    username: PropTypes.string,
    userImage: PropTypes.string,
    lastViewedAt: PropTypes.string,
    permissions: PropTypes.object,
    online: PropTypes.bool
});
